module.exports = __webpack_public_path__ + "static/media/placeholder.e1a484c2.svg";